import React, { useEffect } from 'react';
import '../styles/Football-betting.css'; 

const ReddyAnnaFootballPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="football-betting-page">
      <div className="football-betting-intro">
        <div className="football-betting-intro-content">
          <h1><span>Mahadev Football Betting:</span> Where Every Match Matters!</h1>
          <p>
            Welcome to Mahadev Football Betting — the ultimate playground for football fans who love the game and the thrill of prediction. Whether you're a seasoned punter or just starting out, Mahadev offers a seamless, secure, and electrifying football betting experience.
          </p>
          <div className="football-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="football-betting-intro-image">
          <img src="/football-betting.webp" alt="Football Betting" className="tennis-image" />
        </div>
      </div>

      <section className="football-betting-features">
        <h2>Why Bet with <span>Mahadev Football</span>?</h2>
        <ol>
          <li>
            <strong>Exclusive Football ID:</strong> Get your personalized Mahadev Football ID and access top leagues, live betting, and high-stakes tournaments across the globe.
          </li>
          <li>
            <strong>Fast Registration:</strong> Sign up in minutes and dive straight into the action with a smooth onboarding experience.
          </li>
          <li>
            <strong>Mobile App Access:</strong> Bet on the go! Our mobile-friendly app keeps you connected to live scores, odds, and instant bet placements.
          </li>
          <li>
            <strong>24/7 Customer Support:</strong> Our expert support team is just a message away — ready to assist you anytime via WhatsApp or phone.
          </li>
        </ol>
        <div className="football-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="football-betting-getting-started">
        <h2>How to Get Started with <span>Mahadev Football</span></h2>
        <ol>
          <li>
            <strong>Create Your Account:</strong> Sign up through our website or app to get your Football ID.
          </li>
          <li>
            <strong>Log In & Explore:</strong> Access our platform and discover upcoming matches, betting markets, and live events.
          </li>
          <li>
            <strong>Choose Your Bets:</strong> From the English Premier League to the World Cup, bet on your favorite teams and players with competitive odds.
          </li>
          <li>
            <strong>Watch & Win:</strong> Follow matches live and enjoy the thrill of every pass, goal, and last-minute win.
          </li>
          <li>
            <strong>Need Help?</strong> Our WhatsApp support team is always available to guide you through your journey.
          </li>
        </ol>
      </section>

      <section className="football-betting-join">
        <h2>Join <span>Mahadev Football Betting</span> Today!</h2>
        <p>
          Make every match unforgettable with Mahadev Football Betting. With unbeatable odds, real-time updates, and a trusted betting environment, we bring football fans closer to the game. Join now, play smart, and bet responsibly!
        </p>
        <div className="football-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default ReddyAnnaFootballPage;
